import { Inject, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { AuthService } from '../../services/auth.service';

export interface DialogData {
  regionValidationServiceEnabled: boolean;
}

@Component({
  selector: 'app-idea-sign-dialog',
  templateUrl: './idea-sign-dialog.component.html',
  styleUrls: ['./idea-sign-dialog.component.scss']
})
export class IdeaSignDialogComponent implements OnInit {
  /**
   * The form group
   */
  form: FormGroup;

  /**
   * Session data
   */
  sessionData: { [key: string]: any };

  /**
   * Constructor
   *
   * @param _fb
   * @param _authService
   * @param dialogRef
   */
  constructor(
    private _fb: FormBuilder,
    private _authService: AuthService,
    private _dialogRef: MatDialogRef<IdeaSignDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.form = _fb.group({
      pid: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      birthYear: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.email])]
    });
  }

  /**
   * Init
   */
  ngOnInit() {
    // We do not use unsubscribe, because this observable is disposable
    this._authService.sessionData.subscribe((sessionData) => {
      if (sessionData) {
        // Fill form control values
        Object.keys(this.form.controls).forEach((key) => {
          this.form.controls[key].setValue(sessionData[key]);
        });
      }
    });
  }

  close() {
    this._dialogRef.close(this.form);
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/idea-sign-dialog/idea-sign-dialog.component.ts